import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Typography, styled } from "@mui/material"

import IconArrow from "assets/icons/arrow.svg"
import Button from "components/ui/Button"
import Image from "components/ui/Image"

type Props = React.HTMLAttributes<HTMLButtonElement> & {
  disabled?: boolean
  hidden: boolean
  onClick: () => void
}

const ModalBackComponent = ({
  disabled,
  hidden,
  onClick,
  ...restProps
}: Props) => {
  const { t } = useTranslation()

  const handleClick = (event: React.SyntheticEvent) => {
    if (disabled) {
      event.preventDefault()
      return
    } else {
      onClick()
    }
  }

  return (
    <Container
      sx={{ cursor: disabled ? "default" : "pointer" }}
      hidden={hidden}
      onClick={handleClick}
    >
      <Back disabled={disabled} {...restProps}>
        <Image
          src={IconArrow}
          alt={t("common.back")}
          title={t("common.back")}
        />
      </Back>
      <Typography
        sx={{ opacity: disabled ? "0.5" : "1" }}
        variant="body2"
        component="span"
      >
        {t("common.back")}
      </Typography>
    </Container>
  )
}

ModalBackComponent.defaultProps = {
  hidden: false,
}

export default ModalBackComponent

const Container = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  position: "absolute",
  top: "0",
  left: "35px",
  "&:active": {
    opacity: "0.5",
  },
  [theme.breakpoints.down("lg")]: {
    top: "16px",
    left: "16px",
  },
}))

const Back = styled(Button)(({ theme }) => ({
  background: "rgba(172, 172, 172, 0.1)",
  borderRadius: "50px",
  margin: "0 10px 0 0",
  padding: "0",
  textAlign: "center",
  height: "32px",
  width: "32px",
  "&:active": {
    opacity: "0.5",
  },
  [theme.breakpoints.down("lg")]: {
    margin: "0 5px 0 0",
  },
}))
